import { render } from "./UserProgressPanel.vue?vue&type=template&id=4f903e89&scoped=true"
import script from "./UserProgressPanel.vue?vue&type=script&lang=js"
export * from "./UserProgressPanel.vue?vue&type=script&lang=js"

import "./UserProgressPanel.vue?vue&type=style&index=0&id=4f903e89&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f903e89"]])

export default __exports__